module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/rumble-396b90a8c20d11acf9e969f724fc4aab.png";